import React from 'react';
import PostLink from '../components/PostLink';
import Line from '../components/styledComponents/Line';
import SubHeader from '../components/styledComponents/SubHeader';

export default ({ data }) => {
  const { edges } = data.allMarkdownRemark;
  return (
    <div>
      <SubHeader>Articles</SubHeader>
      {edges.map(edge => [
        <PostLink key={edge.node.id} post={edge.node} />,
        <Line key={`line_${edge.node.id}`} />,
      ])}
    </div>
  );
};

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            path
            title
            description
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js